import { useCallback, useEffect, useMemo, useState } from "react";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import PageTitle from "../../common/PageTitle";
import TabHeader from "../../common/TabHeader";
import Loading from "../../common/Loading";
import NoContent from "../../common/NoContent";
import WebsiteInquiryCard from "./WebsiteInquiryCard";
import { useAppContext } from "../../../providers/ProviderAppContainer";
import { TEXT_NORMAL } from "../../../style";

export default function WebsiteInquiries() {
    const { requestAPI } = useAppContext();
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const [rows, setRows] = useState();
    const [search, setSearch] = useState("");

    const loadRows = useCallback(() => {
        requestAPI({
            requestPath: "website-inquiries",
            requestMethod: "GET",
            setLoading,
            onRequestStart: setError,
            onRequestFailure: setError,
            onResponseReceieved: (data, responseCode) => {
                if (data && responseCode === 200) setRows(data);
                else setError("Couldn't load Website Inquiries");
            },
        });
    }, [requestAPI]);

    useEffect(() => {
        loadRows();
    }, [loadRows]);

    const filteredRows = useMemo(() => {
        const term = String(search || "").trim().toLowerCase();
        if (!term || !rows?.length) return rows || [];
        return rows.filter((row) =>
            [row.full_name, row.phone, row.branch_name, row.course_title, row.description]
                .filter(Boolean)
                .some((value) => String(value).toLowerCase().includes(term)),
        );
    }, [rows, search]);

    return (
        <div className="flex flex-column h-full overflow-hidden">
            <PageTitle title="Website Inquiries" />
            <TabHeader
                className="px-3 pt-3"
                title="Website Inquiries"
                highlights={["Inquiries submitted from the public website form", "Stored separately from app student inquiries"]}
            />
            <Divider />

            <div className="flex align-items-center p-2 gap-1">
                <div className="p-inputgroup flex-1">
                    <InputText
                        value={search}
                        placeholder="Search by name, phone, branch, or course"
                        onChange={(e) => setSearch(e.target.value)}
                        disabled={loading}
                        pt={{ root: { className: TEXT_NORMAL } }}
                    />
                    {!!search && (
                        <Button
                            icon="pi pi-times"
                            className="p-button-danger"
                            disabled={loading}
                            onClick={() => setSearch("")}
                            pt={{ icon: { className: TEXT_NORMAL } }}
                        />
                    )}
                </div>
            </div>

            <div className="flex-1 min-h-0 overflow-y-scroll p-2 bg-gray-100">
                {loading ? (
                    <Loading />
                ) : error ? (
                    <NoContent error={error} />
                ) : filteredRows?.length ? (
                    filteredRows.map((inquiry) => <WebsiteInquiryCard key={inquiry.id} {...inquiry} />)
                ) : (
                    <NoContent error="No Website Inquiries Found" />
                )}
            </div>
        </div>
    );
}
